import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import Vuelidate from 'vuelidate'
import json from '../public/Config.json';
import i18n from './i18n'
import cors from 'cors'
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { BootstrapVue, BPagination } from 'bootstrap-vue'
Vue.use(BootstrapVue, BPagination);
import ElementUI from 'element-ui'
import { DatePicker } from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale });
import 'vue-multiselect/dist/vue-multiselect.min.css';
//import VueQRCodeComponent from 'vue-qrcode-component'



//Vue.component('qr-code', VueQRCodeComponent);
Vue.use(VueSweetalert2);
Vue.use(Vuelidate);
Vue.use(cors);
Vue.use(DatePicker);
Vue.config.productionTip = false;

Vue.component('taxratemodal', require('./components/TaxRate/AddTaxRate.vue').default);
Vue.component('taxratedropdown', require('./components/General/TaxRateDropdown.vue').default);

Vue.component('modal', require('./components/modalcomponent.vue').default);
Vue.component('uploadimage', require('./components/UploadImage.vue').default);
Vue.component('uploadimageview', require('./components/UploadImageView.vue').default);
Vue.component('upload-user-image', require('./components/UploadUserImage.vue').default);
Vue.component('datepicker', require('./components/DatePicker.vue').default);
Vue.component('coa-modal', require('./components/COA/chartOfAccountModal.vue').default);
Vue.component('addupdate-coa', require('./components/COA/AddUpdateAccount.vue').default);
Vue.component('roi-fund-transfer-modal', require('./components/FundTransfer/RoiFundTransferModal.vue').default);
Vue.component('team-bonus-history-modal', require('./components/Team/TeamBonusHistoryModal.vue').default);
Vue.component('roi-history-modal', require('./components/MyPackage/RoiHistoryModal.vue').default);
Vue.component('deposit-detail-modal', require('./components/Deposit/DepositDetailModal.vue').default);
Vue.component('deposit-rejected-modal', require('./components/Deposit/DepositRejectedModal.vue').default);
Vue.component('forgot-password', require('./views/ForgotPassword.vue').default);

//DropDown
Vue.component('team-level-dropdown', require('./components/General/TeamLevelDropdown.vue').default);
Vue.component('accountdropdown', require('./components/General/AccountNumberDropdown.vue').default);
Vue.component('roledropdown', require('./components/General/RoleDropdown.vue').default);
Vue.component('country-dropdown', require('./components/General/CountryDropdown.vue').default);
Vue.component('userdropdown', require('./components/General/UserDropdown.vue').default);
Vue.component('package-plan-dropdown', require('./components/General/PackagePlanDropdown.vue').default);
Vue.component('bankdropdown', require('./components/General/BankDropdown.vue').default);
Vue.component('payment-option-dropdown', require('./components/General/PaymentOptionDropdown.vue').default);
Vue.component('withdrawal-modal', require('./components/Withdrawal/WithdrawalModal.vue').default);
Vue.component('cash-voucher-modal', require('./components/CashVoucher/CashVoucherModal.vue').default);

Vue.component('rejected-reason-modal', require('./components/User/RejectedReasonModal.vue').default);


Vue.prototype.$https = axios;

axios.defaults.baseURL = json.ServerIP;
Vue.prototype.$ServerIp = json.ServerIP;

router.beforeEach((to, from, next) => { // <------------
  
 
  var getLocale = localStorage.getItem('locales');
    let language = getLocale;
  if(!language) {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
      language = 'en';
  }
  i18n.locale = language;
  next();
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
